import { ApiUtil as api } from '@/utils/api.util.js'

export class UserService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/persons/'

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static store(data = {}) {
    return api.post(this.URL + this.RESOURCE, data)
  }

  static show(id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id, queryParams).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static update(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id, data)
  }

  static delete(id) {
    return api.delete(this.URL + this.RESOURCE + id)
  }

  static toggleActiveStatus(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/active', data).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static archive(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/archive', data)
  }

  static restore(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/restore', data)
  }


  static updateRole(queryParams = {}) {

    return api.post(this.URL + this.RESOURCE + 'update/role', queryParams).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static userById(queryParams = {}) {

    return api.post(this.URL + this.RESOURCE + 'get-user/by-id', queryParams).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static updateAttribute(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/attribute', data)
  }

  static createFirmAssociation(id, data = {}) {
    return api.post(this.URL + this.RESOURCE + id + '/firms', data)
  }

  static deleteFirmAssociation(id, firmId, data = {}) {
    return api.delete(this.URL + this.RESOURCE + id + '/firms/' + firmId, data)
  }

  static assignCodes(data = {}) {
    return api.post(this.URL + this.RESOURCE + 'assign/codes', data)
  }
  static search(firm, keyword) {
    return api.get(this.URL + this.RESOURCE + 'search/' + firm + '/' + keyword)
  }
  static getManagers(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'get/managers/', queryParams)
  }
  static getTeleportActivity(id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id + '/teleport_activity', queryParams)
  }

  static listContracts(id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id + '/contracts', queryParams)
  }

  static archiveContracts(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/archive-contracts', queryParams)
  }

  static restoreContracts(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/restore-contracts', queryParams)
  }
}



// WEBPACK FOOTER //
// ./src/services/user.service.js